import PalowansWithDaysToExpireTable from './PalowansWithDaysToExpireTable';

export default PalowansWithDaysToExpireTable;
